import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Box, Container, Typography } from '@mui/material'

const Settings = () => {
  const location = useLocation()
  const isLayoutEditorRoute = /^\/settings\/controlpanel\/products\/[^/]+\/layout-editor(?:\/|$)/.test(location.pathname)

  if (isLayoutEditorRoute) {
    return (
      <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>
    )
  }

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Configuración
      </Typography>
      <Outlet />
    </Container>
  )
}

export default Settings
